export default {
  'app.setting.pagestyle': 'Ustawienia styli strony',
  'app.setting.pagestyle.dark': 'Ciemny motyw',
  'app.setting.pagestyle.light': 'Jasny motyw',
  'app.setting.content-width': 'Długość treści',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.themecolor': 'Kolor motywu',
  'app.setting.themecolor.dust': 'Czerwony kurz',
  'app.setting.themecolor.volcano': 'Wulkan',
  'app.setting.themecolor.sunset': 'Pomarańczowy zachód',
  'app.setting.themecolor.cyan': 'Jasnoniebieskie',
  'app.setting.themecolor.green': 'Polarny zielony',
  'app.setting.themecolor.daybreak': 'Niebieski świt (domyślny)',
  'app.setting.themecolor.geekblue': 'Geek glue',
  'app.setting.themecolor.purple': 'Złoto-fioletowy',
  'app.setting.navigationmode': 'Tryb nawigacji',
  'app.setting.sidemenu': 'Układ menu bocznego',
  'app.setting.topmenu': 'Układ górnego menu',
  'app.setting.fixedheader': 'Nieruchomy nagłówek',
  'app.setting.fixedsidebar': 'Nieruchomy pasek boczny',
  'app.setting.fixedsidebar.hint': 'Pracujesz na układzie menu bocznego',
  'app.setting.hideheader': 'Ukryty header podczas przesuwania',
  'app.setting.hideheader.hint': 'Działa, gdy włączony jest ukryty nagłówek',
  'app.setting.othersettings': 'Inne opcje',
  'app.setting.weakmode': 'Tryb słaby',
  'app.setting.copy': 'Skopiuj opcję',
  'app.setting.copyinfo':
    'Kopiowanie zakończono sukcesem，zmień defaultSettings in src/models/setting.js',
  'app.setting.production.hint':
    'Panel ustawień wyświetla się tylko w środowisku programistycznym, zmodyfikuj ręcznie',
};
